import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, CardBody, FormGroup, Input, Label, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import { getSystemSettings, updateSystemSettings } from '../../services/systemSettingsService';
import VfdSettingsPanel from './VfdSettingsPanel';

const POSSettingsPage = () => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getSystemSettings()
      .then(({ data }) => setEnabled(data?.droitTimbreEnabled !== false))
      .catch(() => setError('Impossible de charger les paramètres de caisse.'))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    setError('');
    try {
      const { data } = await updateSystemSettings({ droitTimbreEnabled: enabled });
      setEnabled(data?.droitTimbreEnabled !== false);
      await Swal.fire('Enregistré', 'Les paramètres de caisse ont été mis à jour.', 'success');
    } catch (_) {
      setError("Impossible d'enregistrer les paramètres de caisse.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card>
      <CardBody>
        <h4 className="mb-4">Paramètres de caisse</h4>
        {error && <Alert color="danger">{error}</Alert>}
        {loading ? (
          <Spinner size="sm" />
        ) : (
          <>
            <FormGroup switch className="mb-2">
              <Input
                type="switch"
                id="droit-timbre-enabled"
                checked={enabled}
                onChange={(event) => setEnabled(event.target.checked)}
              />
              <Label for="droit-timbre-enabled" check>
                Activer le droit de timbre (0,25 %)
              </Label>
            </FormGroup>
            <p className="text-muted">
              Lorsqu'il est désactivé, le droit de timbre n'est ni calculé ni affiché sur les nouvelles ventes.
            </p>
            <Button color="primary" disabled={saving} onClick={save}>
              {saving ? 'Enregistrement…' : 'Enregistrer'}
            </Button>
            <VfdSettingsPanel />
          </>
        )}
      </CardBody>
    </Card>
  );
};

export default POSSettingsPage;
